import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonSettingsService } from './common.setting.service';
import { SharedUserService } from './user.service';
import { CommonService } from '../services/Common.service';
import { UserService } from '../services/User.service';
import { GroupService } from '../services/Group.service';
import { EvsAddressService } from '../services/EvsAddress.service';
import { CampaignService } from '../services/Campaign.service';
import { FieldService } from '../services/Field.service';
@NgModule({
  imports: [CommonModule],
  declarations: [],
  exports: [],
  providers: [
    CommonService,
    EvsAddressService,
    UserService,
    CampaignService,
    FieldService,
    GroupService,
    CommonSettingsService,
    SharedUserService,
  ],
})
export class SharedDataModule {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/common/share-data/shared.data.module.ts